// extracted by mini-css-extract-plugin
export default {"journeyBck":"Journey_journeyBck__LToyQ","journeyBox":"Journey_journeyBox__YQt7A","journeyDis":"Journey_journeyDis__rgrfN"};